<div class="date-time text-uppercase col-gray-500" *ngIf="small; else big">
  <ng-container [ngTemplateOutlet]="text"></ng-container>
</div>

<ng-template #big>
  <div class="date-time--big d-flex align-items-center">
    <div class="date-time__icon"></div>
    <div class="">
      <div class="text-small col-gray-500">Date & Time</div>
      <div class="dark semi-bold text-small">
        <ng-container [ngTemplateOutlet]="text"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #text>
  <span class="bold text-small">{{ dateTime | date: "EEE, MMM d, y" }}</span>
  <span class="pr-1 pl-1 text-small">at</span>
  <span class="bold text-small">{{ dateTime | date: "HH:mm" }}</span>
</ng-template>
